export default function StudentTestimonials() {
  const testimonials = [
    {
      name: 'Tiara Murli Adila',
      position: 'SPV Project Development Engineer',
      image: '/img/gijinkoku/YES---2-1.png',
      text: 'Pelatihan ini sangat berkesan berkat kelas yang interaktif, mentor yang profesional, tim yang sigap, serta materi yang berfokus pada praktik percakapan, penyusunan kalimat, dan kosakata yang relevan dalam kehidupan sehari-hari.',
    },
    {
      name: 'Sabril Prajudith Pangestu',
      position: 'Junior Data Entry',
      image: '/img/gijinkoku/YES---3-1.png',
      text: 'Sebagai student yang bisa dibilang belajar Bahasa Jepang dari 0, program ini sangat membantu dalam akselerasi pemahaman Bahasa Jepang, yang mana diperlukan untuk persiapan tes JLPT sebagai syarat untuk bisa bekerja di Jepang.',
    },
    {
      name: 'Muttafiah',
      position: 'Web Developer',
      image: '/img/gijinkoku/YES---5-1.png',
      text: 'Sensei yang ramah dan interaktif membuat setiap sesi belajar menjadi seru dan mudah dipahami. Programnya sangat membantu saya dalam meningkatkan kemampuan Bahasa Jepang.',
    },
  ]

  return (
    <section className="bg-[#f7f8ff] py-16">
      <div className="max-w-8xl mx-auto px-6">
        <div className="mb-16 text-center">
          <h2 className="text-3xl font-bold text-gray-700">
            What Our Students Say
          </h2>
        </div>

        {/* Desktop Testimonials */}
        <div>
          <div className="flex flex-wrap justify-center gap-10 pb-4">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="relative min-w-[352px]">
                <div
                  className="relative flex h-[190px] w-[352px] items-center justify-end rounded-lg p-5"
                  style={{
                    backgroundImage:
                      "url('https://cdn.prod.website-files.com/66ce8377eef3a0d75bce4265/6836cf32a73d26aefbfdf889_Vector%202401.png')",
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                  }}
                >
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="absolute -left-8 top-16 h-auto w-[130px]"
                  />
                  <div className="z-10 ml-auto max-w-[230px] text-left text-xs leading-tight text-white">
                    <div className="mb-2">{testimonial.text}</div>
                    <div className="font-bold">{testimonial.name}</div>
                    <div className="font-bold">{testimonial.position}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
